module.exports = __webpack_public_path__ + "static/img/qq.d175dd04.png";